var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogout = function SvgLogout(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.893 13.133H.2v-2.266H13.375l-.34-.342-3.3-3.311 1.598-1.598L17.717 12l-6.384 6.384-1.597-1.598 3.299-3.312.34-.34h-.482ZM2.667 2.467h-.2V7.8H.2V2.667A2.467 2.467 0 0 1 2.667.2h18.666A2.475 2.475 0 0 1 23.8 2.667v18.666a2.475 2.475 0 0 1-2.467 2.467H2.667A2.467 2.467 0 0 1 .2 21.333V16.2h2.267v5.333h19.066V2.467H2.667Z",
    fill: "#080707",
    stroke: "#fff",
    strokeWidth: 0.4
  })));
};
export default SvgLogout;